import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const editLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  `;

  const amountCell = css`
    text-align: right;
  `;

  const total = css`
    text-align: right;
    padding-right: 15px;
    font-size: 22px;
    margin-top: -10px;
    color: ${theme.colors.navy["1"]};
  `;

  return {
    page,
    editLink,
    amountCell,
    total,
  };
};

export default useStyles;
